import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
    scrollBehavior(to, from, savedPosition) {
        const hist = window.history.state as { noScroll?: boolean } | null

        if (hist?.noScroll) {
            return savedPosition || false
        }
        if (savedPosition) {
            return savedPosition
        }
        return { top: 0, behavior: 'smooth' }
    }
}
